import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	invalidUrl: {
		id: 'servicedesk-customer-service-custom-details.common.field.url-field.invalid-url',
		defaultMessage: 'Enter a URL with the format: http://example.com',
		description: 'Validation error message in red text shown when entry is not a valid URL.',
	},
});
